import { useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { QUERY_KEYS } from '~shared/api/query-keys';

import type { StudentSearch } from '../modal/student-search';

export const getStudentsRelationsByParentId = async (parentId: string) => {
  const response = await baseAPI.get<Array<StudentSearch>>(
    `/students/${parentId}/relations`,
  );
  return response.data;
};

export const useGetStudentsRelationsByParentId = (parentId: string) => {
  return useQuery({
    queryKey: QUERY_KEYS.STUDENT_RELATIONS(parentId),
    queryFn: () => getStudentsRelationsByParentId(parentId),
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
};
